export default __webpack_public_path__ + "static/media/RhymesColors_09.8317c272.png";